import { DISPATCH_TARGET } from "../../../../shared/constants/dispatchTarget";
import DispatchList from "../../../../components/units/Management/Dispatch/List";

export default function DispatchEndUserPage() {
  return (
    <DispatchList target={DISPATCH_TARGET.endUser} initSearchType="from" />
  );
}
